import { defineNuxtPlugin } from 'nuxt/app'

import { registerAnalyticsContextResolver, resolveDefaultAnalyticsContext } from '@common/analytics-layer/tracking/analytics-context'
import { useGlobal } from '@common/core-layer/composables/useGlobal'

import { resolveGroupLocation } from '@communities/groups-layer/utils/resolve-group-location.resolver'
import { resolveCommunityGroupSlugFromPath } from '../utils/resolve-community-group-route'
import { registerCommunityTrafficAnalyticsProvider } from '../utils/register-community-traffic-analytics-provider.utils'

/**
 * Communities analytics bootstrap (client):
 * 1. CP group-route PAGE_VIEW context — wait until loaded group slug matches route.
 * 2. Traffic KPI ingest — fan out PAGE_VIEW to community-analytics traffic API.
 */
export default defineNuxtPlugin({
  name: 'community-analytics',
  enforce: 'post',
  setup() {
    const { isGokollab } = useGlobal()

    if (!isGokollab.value) {
      registerAnalyticsContextResolver(async (route, options) => {
        const routeSlug = resolveCommunityGroupSlugFromPath(route.path)
        if (!routeSlug) return resolveDefaultAnalyticsContext()

        const locationId = await resolveGroupLocation(routeSlug, options.signal)
        const base = resolveDefaultAnalyticsContext()
        return {
          ...base,
          locationId,
        }
      })
    }

    registerCommunityTrafficAnalyticsProvider()
  },
})
